export const companyReportsData = [
  {
    key: "1",
    companyLocation: "NovaWave LLC",
    phone: "+1 875455453",
    email: "robertson@example.com",
    location: "Germany",
    owner: "Hendry",
    source: "Paid Social",
    wonDeals: "5 Deals, $100000",
    lostDeals: "2 Deals, $80000",
    dateCreated: "25 Sep 2023, 01:22 pm",
    companyLogo: "assets/img/icons/company-icon-01.svg",
  },
  {
    key: "2",
    companyLocation: "BlueSky Industries",
    phone: "+1 989757485",
    email: "sharon@example.com",
    location: "USA",
    owner: "Guillory",
    source: "Referrals",
    wonDeals: "4 Deals, $120000",
    lostDeals: "3 Deals, $90000",
    dateCreated: "29 Sep 2023, 04:15 pm",
    companyLogo: "assets/img/icons/company-icon-02.svg",
  },
  {
    key: "3",
    companyLocation: "SilverHawk",
    phone: "+1 546555455",
    email: "vaughan12@example.com",
    location: "Canada",
    owner: "Jami",
    source: "Campaigns",
    wonDeals: "3 Deals, $110000",
    lostDeals: "2 Deals, $70000",
    dateCreated: "04 Oct 2023, 10:18 am",
    companyLogo: "assets/img/icons/company-icon-03.svg",
  },
  {
    key: "4",
    companyLocation: "SummitPeak",
    phone: "+1 454478787",
    email: "jessica13@example.com",
    location: "India",
    owner: "Theresa",
    source: "Google",
    wonDeals: "6 Deals, $200000",
    lostDeals: "3 Deals, $100000",
    dateCreated: "17 Oct 2023, 03:31 pm",
    companyLogo: "assets/img/icons/company-icon-04.svg",
  },
  {
    key: "5",
    companyLocation: "RiverStone Ventur",
    phone: "+1 124547845",
    email: "caroltho3@example.com",
    location: "China",
    owner: "Espinosa",
    source: "Paid Social",
    wonDeals: "3 Deals, $80000",
    lostDeals: "1 Deal, $40000",
    dateCreated: "24 Oct 2023, 09:14 pm",
    companyLogo: "assets/img/icons/company-icon-05.svg",
  },
  {
    key: "6",
    companyLocation: "Bright Bridge Grp",
    phone: "+1 478845447",
    email: "dawnmercha@example.com",
    location: "Japan",
    owner: "Martin",
    source: "Referrals",
    wonDeals: "5 Deals, $95000",
    lostDeals: "2 Deals, $60000",
    dateCreated: "08 Nov 2023, 09:56 am",
    companyLogo: "assets/img/icons/company-icon-06.svg",
  },
  {
    key: "7",
    companyLocation: "CoastalStar Co.",
    phone: "+1 215544845",
    email: "rachel@example.com",
    location: "Indonesia",
    owner: "Newell",
    source: "Campaigns",
    wonDeals: "4 Deals, $100000",
    lostDeals: "1 Deal, $50000",
    dateCreated: "14 Nov 2023, 04:19 pm",
    companyLogo: "assets/img/icons/company-icon-07.svg",
  },
  {
    key: "8",
    companyLocation: "HarborView",
    phone: "+1 121145471",
    email: "jonelle@example.com",
    location: "Cuba",
    owner: "Janet",
    source: "Google",
    wonDeals: "3 Deals, $70000",
    lostDeals: "3 Deals, $80000",
    dateCreated: "23 Nov 2023, 11:14 pm",
    companyLogo: "assets/img/icons/company-icon-08.svg",
  },
  {
    key: "9",
    companyLocation: "Golden Gate Ltd",
    phone: "+1 321454789",
    email: "jonathan@example.com",
    location: "Isreal",
    owner: "Craig",
    source: "Referrals",
    wonDeals: "6 Deals, $130000",
    lostDeals: "4 Deals, $100000",
    dateCreated: "10 Dec 2023, 06:43 am",
    companyLogo: "assets/img/icons/company-icon-09.svg",
  },
  {
    key: "10",
    companyLocation: "Redwood Inc",
    phone: "+1 278907145",
    email: "brook@example.com",
    location: "Colombia",
    owner: "Daniel",
    source: "Campaigns",
    wonDeals: "5 Deals, $90000",
    lostDeals: "2 Deals, $55000",
    dateCreated: "25 Dec 2023, 08:17 pm",
    companyLogo: "assets/img/icons/company-icon-10.svg",
  },
];
